import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sb",
  "use": "icon-sb-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sb\"><defs><style type=\"text/css\"></style></defs><path d=\"M911.29856 479.33952 911.29856 52.34176 117.36064 52.34176l0 426.99264L51.2 479.3344l0 433.58208c0 32.82432 26.46528 59.06944 52.93568 59.06944l813.7728 0c33.08032 0 52.9408-26.24512 52.9408-52.48512l0-440.1664L911.29856 479.3344 911.29856 479.33952M183.52128 170.59328l661.62688 0 0 308.74624L183.52128 479.33952 183.52128 170.59328 183.52128 170.59328M236.45696 236.30336l549.13536 0 0 59.12576L236.45696 295.42912 236.45696 236.30336 236.45696 236.30336M236.45696 361.088l549.13536 0 0 59.17184L236.45696 420.25984 236.45696 361.088 236.45696 361.088M236.45696 361.088 236.45696 361.088z\" p-id=\"6873\" fill=\"#303133\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sb.svg
// module id = 05dd
// module chunks = 16